import { User, ClipboardList, Home, Users, CalendarCheck, MessageSquare } from "lucide-react";

const BENEFITS = [
  { icon: User, title: "One Point of Contact", text: "One team to coordinate your renovation." },
  { icon: ClipboardList, title: "Clear Scope", text: "Understand what is included before work starts." },
  { icon: Home, title: "Complete Renovation", text: "From demolition and MEP to finishing and handover." },
  { icon: Users, title: "Coordinated Trades", text: "Different renovation trades managed under one project." },
  { icon: CalendarCheck, title: "Professional Project Management", text: "Organized execution from start to completion." },
  { icon: MessageSquare, title: "Clear Communication", text: "One team to discuss your requirements." },
];

export default function Trust() {
  return (
    <section id="why-us" data-testid="why-us-section" className="py-20 lg:py-28 bg-[#F9F8F6]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-3xl mx-auto mb-12 lg:mb-16">
          <p className="text-[11px] uppercase tracking-[0.25em] text-[#C5A059] font-semibold mb-3">
            Why One Team
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-neutral-900 mb-4 leading-[1.1]">
            One Team for Your Complete Renovation
          </h2>
          <p className="text-base lg:text-lg text-neutral-600">
            No juggling multiple contractors — your entire renovation is coordinated under one professional team.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-5">
          {BENEFITS.map((b, i) => (
            <div
              key={b.title}
              data-testid={`why-us-point-${i}`}
              className="bg-white border border-neutral-200 p-6 lg:p-7 hover:border-[#C5A059] transition-colors flex flex-col gap-3"
            >
              <div className="w-10 h-10 bg-[#C5A059]/10 flex items-center justify-center">
                <b.icon className="w-5 h-5 text-[#C5A059]" />
              </div>
              <h3 className="font-heading text-base lg:text-lg font-semibold text-neutral-900 leading-snug uppercase tracking-wide">
                {b.title}
              </h3>
              <p className="text-sm text-neutral-600 leading-relaxed">{b.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
